import { Link, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex flex-1 items-center justify-center pt-16 md:pt-[72px] px-4">
        <div className="text-center">
          <span className="font-heading text-7xl md:text-9xl text-primary-500">404</span>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">找不到这个页面</h1>
          <p className="mt-3 text-sm text-foreground-500">您访问的地址不存在或已被移除。</p>
          <p className="mt-1 text-xs text-foreground-400 font-mono">{location.pathname}</p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line"></i> 返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}